import { useSelector } from "react-redux";
import type { HotelCardPriceComponentProps } from "@tenant/hotels";
import { PackagePriceText, usePackagePrice } from "@tenant/packages";
import { PackageHotelSelectors } from "@/store/packages";

export const HotelCardPrice = (props: HotelCardPriceComponentProps) => {
  const hotelId = props.hotel.lodging.id;

  const packageStatebyLodgingId = useSelector(
    PackageHotelSelectors.getPackageStateByLodgingId
  );
  const price = packageStatebyLodgingId?.[hotelId]?.price;
  const {
    context: { showPointsPricing, hasTenantSpecific, text, packageType },
  } = usePackagePrice(price);

  return (
    <PackagePriceText
      showPointsPricing={showPointsPricing}
      hasTenantSpecific={hasTenantSpecific}
      unitPriceRewards={text.perUnitRewards}
      unitPrice={text.perUnitPrice}
      totalPrice={text.totalPrice}
      packageType={packageType}
    />
  );
};
